import { $api } from "../AxiosInstance";

export class SiteService {
  /**
   * Get all sites
   */
  static async siteGetAll() {
    return await $api.get("/api/site/get/all");
  }

  /**
   * Get all top sites
   */
  static async siteTopGetAll() {
    return await $api.get("/api/site/top");
  }

  /**
   * Add site to top
   * @param {Number} siteId
   */
  static async siteTopAdd(siteId) {
    return await $api.post("/api/site/top/create", { siteId });
  }

  /**
   * Save site top
   * @param {Object} siteTop
   */
  static async siteTopSave(siteTop) {
    return await $api.post("/api/site/top", { siteTop });
  }

  /**
   * Delete site top
   * @param {Number} id
   */
  static async siteTopDelete(id) {
    return await $api.delete("/api/site/top", { params: { id } });
  }

  /**
   * Get all proxy sites
   */
  static async siteProxyGetAll() {
    return await $api.get("/api/site/proxy/get/all");
  }

  /**
   * Delete site
   * @param {Number} id
   */
  static async siteDelete(id) {
    return await $api.delete("/api/site", { params: { id } });
  }

  /**
   * Delete proxy site
   * @param {Number} id
   */
  static async siteProxyDelete(id) {
    return await $api.delete("/api/site/proxy", { params: { id } });
  }

  /**
   * Delete proxy site image
   * @param {Number} id
   */
  static async siteProxyDeleteImage(id) {
    return await $api.delete("/api/site/proxy/image", { params: { id } });
  }

  /**
   * Save proxy site
   */
  static async siteProxySave(
    id,
    name,
    email,
    description,
    link,
    freeTest,
    individual,
    replacementPossibility,
    countries,
    ipType,
    purposeUse,
    priceMax,
    minRentPeriod,
    clientNoAuth,
    clientLoginAuth,
    clientIPAuth,
    refunds,
    affiliateProgram,
    userId,
    promoCode
  ) {
    return await $api.post("/api/site/proxy", {
      id,
      name,
      email,
      description,
      link,
      freeTest,
      individual,
      replacementPossibility,
      countries,
      ipType,
      purposeUse,
      priceMax,
      minRentPeriod,
      clientNoAuth,
      clientLoginAuth,
      clientIPAuth,
      refunds,
      affiliateProgram,
      userId,
      promoCode,
    });
  }

  /**
   * Get proxy site by ID
   * @param {Number} id
   */
  static async siteProxyGet(id) {
    return await $api.get("/api/site/proxy", { params: { id } });
  }
}
